import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/wug-torino-2025.svg'
import _imports_1 from '@/assets/images/3bmeteo.svg'


const _hoisted_1 = { class: "home h-100 bg-grey-lighten-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_bollettini = _resolveComponent("bollettini")!
  const _component_loader = _resolveComponent("loader")!
  const _component_previsione = _resolveComponent("previsione")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      fluid: "",
      "scroll-behavior": "elevate",
      class: "d-flex justify-space-between ma-0 px-sm-25 pt-2 pb-4 pb bg-indigo-darken-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "w-auto ml-0 d-flex align-center"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              class: "w-70px w-sm-100px",
              src: _imports_0
            }, null, -1),
            _createElementVNode("img", {
              class: "w-70px w-sm-100px",
              src: _imports_1
            }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_container, {
          fluid: "",
          class: "w-auto mr-0 d-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_menu, {
              location: "bottom",
              "close-on-content-click": false
            }, {
              activator: _withCtx(({ props, isActive }) => [
                _createVNode(_component_v_chip, _mergeProps(props, { class: "bg-grey-lighten-3 h-auto pl-0 my-auto" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "rounded-lg bg-blue-darken-4 rounded-circle pa-3 mr-2 user-select-none" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getUserInitialsFromUser(_ctx.user)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_icon, {
                      icon: "mdi-chevron-down",
                      class: _normalizeClass([ isActive ? 'rotate-180' : '' ])
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, { class: "bg-white pa-4 rounded-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "h-100 rounded-lg bg-blue-darken-4 rounded-circle pa-3 mr-2 my-auto flex-0-0-0 user-select-none" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getUserInitialsFromUser(_ctx.user)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "pa-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-body-1 text-weight-medium pa-0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.user?.name) + " " + _toDisplayString(_ctx.user?.surname), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_container, { class: "text-caption pa-0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.user?.email), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, { thickness: "1" }),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _ctx.logout,
                      class: "w-100 h-auto mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, { class: "px-0 py-2 w-100 text-start" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('home.menu.logout')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.bollettini.loading)
      ? (_openBlock(), _createBlock(_component_bollettini, {
          key: 0,
          bollettini: _ctx.bollettini.data
        }, null, 8, ["bollettini"]))
      : _createCommentVNode("", true),
    (_ctx.bollettini.loading)
      ? (_openBlock(), _createBlock(_component_loader, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_previsione, {
      loading: _ctx.previsioni.loading,
      previsioni: _ctx.previsioni.data,
      "localita-tabs": _ctx.localitaTabsList,
      onLocalitaChanged: _cache[0] || (_cache[0] = (data) => _ctx.getMeteoLocalita(data.localitaId))
    }, null, 8, ["loading", "previsioni", "localita-tabs"]),
    _createVNode(_component_v_container, { class: "bg-white mt-7 d-flex justify-space-between mb-10 flex-column flex-sm-row" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "w-auto ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "pa-0 ma-0 d-block d-sm-inline-block w-auto" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('home.footer.call')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_container, { class: "pa-0 ma-0 ml-2 d-block d-sm-inline-block w-auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "18",
                  icon: "mdi-phone-outline",
                  class: "pa-0 mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('home.footer.supportPhoneNumber')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_container, { class: "w-auto ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "pa-0 ma-0 d-block d-sm-inline-block w-auto" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('home.footer.write')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_container, { class: "pa-0 ma-0 ml-2 d-block d-sm-inline-block w-auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "18",
                  icon: "mdi-email-outline",
                  class: "pa-0 mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('home.footer.supportEmail')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar.opened,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.snackbar.opened) = $event)),
      timeout: 3000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`snackbar.${ _ctx.snackbar.message }`)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}